import { principles } from "../../../mocks/trendData";

const stats = [
  { value: "900+", label: "已归档事件脉络" },
  { value: "3700+", label: "标注来源口径" },
  { value: "每 20 分钟", label: "人工巡检更新" },
];

export default function Principles() {
  return (
    <section id="principles" className="bg-background-50 py-10 md:py-14">
      <div className="container-x">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <span className="section-kicker">关于沸点追踪</span>
            <h2 className="mt-3 font-heading text-xl font-black leading-snug tracking-tight text-foreground-950 md:text-3xl">
              我们把"吃瓜"，变成一门"核实"的功课
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700">
              沸点追踪是一群内容编辑与舆情观察者组建的热点事件追踪站。面对信息反转频繁、截图真假难辨的舆论场，
              我们选择用最朴素的方式建立信任：先理时间线、多源交叉、口径并列、辟谣同步更新。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              我们不做未经核实的二次传播，也不替读者预判对错。这里的目标始终是——让你在最短时间内，
              知道一件事"现在走到哪一步、哪些还没结论"，从而做出自己的判断。
            </p>

            <div className="mt-6 grid grid-cols-3 gap-3">
              {stats.map((s) => (
                <div key={s.label} className="rounded-lg border border-background-200 bg-background-100 p-3 text-center md:p-4">
                  <div className="font-heading text-base font-black text-accent-600 md:text-xl">{s.value}</div>
                  <div className="mt-1 text-[11px] leading-snug text-foreground-600 md:text-xs">{s.label}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
              {principles.map((p) => (
                <article
                  key={p.title}
                  className="flex flex-col rounded-lg border border-background-200 bg-background-100 p-4 md:p-5"
                >
                  <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-100 text-primary-600">
                    <i className={`${p.icon} text-lg`} aria-hidden="true"></i>
                  </span>
                  <h3 className="mt-3 text-sm font-bold text-foreground-950 md:text-base">{p.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{p.text}</p>
                </article>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}